
export default {
  props: {
    material: {
      type: Object,
      default: null,
    },
  },
  computed: {
    materialEntity() {
      switch (this.material?.type) {
        case 'article':
          return 'Статья'
        case 'video':
          return 'Видео'
        case 'telegram':
          return 'Материал'

        default:
          return 'Материал'
      }
    },

    shareTitle() {
      if (this.material?.title) {
        return this.material.title
      } else if (this.material?.text) {
        const text = this.material.text
        if (text?.blocks?.length) {
          let preText = text.blocks.filter(
            (block) => block.type === 'paragraph'
          )
          preText = preText.slice(0, 1).map((p) => {
            return p.data.text
          })

          preText = preText.join(' ')
          const sanitizeText = preText.replace(/<a[^>]*>|<\/a>/gi, '') // Вырезаем тег ссылки
          return sanitizeText
        }
      }
      return null
    },
    shareDescription() {
      if (this.material?.description) {
        return this.material.description
      } else if (this.material?.text) {
        const text = this.material.text
        if (text?.blocks?.length) {
          let preText = text.blocks.filter(
            (block) => block.type === 'paragraph'
          )
          preText = preText.slice(0, 3).map((p) => {
            return p.data.text
          })

          preText = preText.join(' ')
          const sanitizeText = preText.replace(/<a[^>]*>|<\/a>/gi, '') // Вырезаем тег ссылки
          return sanitizeText
        }
      }
      return null
    },
  },
}
